import { render, staticRenderFns } from "./Createcourse.vue?vue&type=template&id=4269ffa0&scoped=true"
import script from "./Createcourse.vue?vue&type=script&lang=js"
export * from "./Createcourse.vue?vue&type=script&lang=js"
import style0 from "./Createcourse.vue?vue&type=style&index=0&id=4269ffa0&prod&lang=less&scoped=true"
import style1 from "./Createcourse.vue?vue&type=style&index=1&id=4269ffa0&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4269ffa0",
  null
  
)

export default component.exports